<template>
  <content-list />
</template>

<script>
import { CONTENT_TYPE_DEFS } from '@/service/utils/constants'

export default {
  name: 'gl-event-list',
  version: '0.0.1',
  props: {
    instKey: {
      type: String,
      required: true
    },
    keyListFilter: {
      type: String,
      required: false
    },
    tagListFilter: {
      type: String,
      required: false
    }
  }, // props
  provide () {
    return {
      contentType: CONTENT_TYPE_DEFS.EVENT,
      instKey: () => this.instKey,
      keyListFilter: () => this.keyListFilter,
      tagListFilter: () => this.tagListFilter
    }
  }, // provide
  components: {
    ContentList: () => import('@/components/content/ContentList.vue')
  }, // components
  data () {
    return {
      formData: {}
    }
  }, // data
  /* ----- vuejs hooks ----- */
  mounted () {}, // mounted
  computed: {}, // computed
  watch: {}, // watch
  methods: {} // methods
}
</script>

<style lang="css" scoped>
@import '~bootstrap/dist/css/bootstrap.css';
</style>
